import { formatMoney } from '@spa/shared/utils';

export const validateMonthRentChange = (t, language, startDate, endDate, rents) => {
  if (!startDate || !endDate || !rents) {
    return { warning: null };
  }
  const rentValues = rents.map(({ amount }) => amount);
  const doesMonthRentChange = [...new Set(rentValues)].length > 1;

  if (!doesMonthRentChange) {
    return { warning: null };
  }

  const [{ currency_code: currency }] = rents;
  const lowRent = formatMoney(Math.min(...rentValues), currency, language);
  const highRent = formatMoney(Math.max(...rentValues), currency, language);

  return {
    warning: t('The rent changes from month to month, from {{lowRent}} to {{highRent}}', { lowRent, highRent })
  };
};
